module.exports = __webpack_public_path__ + "img/vue2-corpsavant_blanc.9a2ea961.png";